import React from "react";

import { SearchRounded } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

import { GreyPallet } from "../../../config/styles";

import MainText from "../../MainText";

type SearchMainProps = {
  name: string;
  value: string | undefined;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
  small?: string | JSX.Element;
  shrink?: boolean;
};

export default function SearchMain({
  name,
  value,
  onChange,
  onSubmit,
  loading,
  disabled,
  small,
  shrink = true,
}: SearchMainProps) {
  const [fieldValue, setFieldValue] = React.useState<string | undefined>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const eventValue = event.currentTarget.value as string;
    setFieldValue(eventValue);
    onChange(eventValue);
  };

  return (
    <FormControl
      fullWidth
      sx={{
        "& .MuiFormLabel-root": {
          fontWeight: "bold",
          color: `${GreyPallet.Regular} !important`,
        },
        mb: 2,
      }}
      variant="outlined"
    >
      <InputLabel shrink={shrink}>{name}</InputLabel>
      <OutlinedInput
        notched={shrink}
        autoCapitalize="words"
        value={value}
        disabled={disabled}
        onChange={handleChange}
        type={"text"}
        label={name}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={onSubmit} edge="end">
              {loading ? (
                <CircularProgress style={{ color: GreyPallet.Regular, width: 26, height: 26 }} />
              ) : (
                <SearchRounded />
              )}
            </IconButton>
          </InputAdornment>
        }
        sx={{
          borderRadius: "15px",

          height: 60,
          fontWeight: "bold",
          fontSize: 16,
          color: GreyPallet.Regular,

          "& .MuiSvgIcon-root": {
            fontSize: 26,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "3px !important",
            borderColor: `${GreyPallet.Light} !important`,
            borderStyle: "solid",
            "& .Mui-focused": {
              borderColor: `${GreyPallet.Regular} !important`,
            },
          },
        }}
      />
      {small ? (
        <Box mt={1}>
          <MainText size="small" color="regular">
            {small}
          </MainText>
        </Box>
      ) : null}
    </FormControl>
  );
}
